import { MutationKey } from '@tanstack/react-query';

const base: MutationKey = ['otp'];

export const otpMutationKeys = {
  // * BASE
  baseKey: base,

  // * Verify Otp
  verifyOtp: [...base, 'verifyOtp'],
};